import React from "react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import RadioButtons from "components/ReactHookForm/RadioButtons"
import { Boolean } from "utilities/enums"
import { Flex, Text } from "@chakra-ui/react"

type Props = {
  onHide: () => void
  guestCount: number
  cloneEvent: (includeGuests: boolean) => Promise<void>
}

const CLONE_WITH_GUESTS_LIMIT = 10000

const CloneEvent = ({ onHide, guestCount, cloneEvent }: Props) => {
  const guestNumberExceedsLimit = guestCount > CLONE_WITH_GUESTS_LIMIT

  const options = [
    {
      label: <Text fontSize="xl">Clone without guests</Text>,
      value: Boolean.False,
      additionalElement: (
        <Text mt={-6} ml={7}>
          Copies event settings, emails, texts, badges, tables, registration forms, and web page.
        </Text>
      ),
    },
    {
      label: <Text fontSize="xl">Clone with guests</Text>,
      value: Boolean.True,
      additionalElement: (
        <Text mt={-6} ml={7}>
          Copies everything above and also adds guests to the new event with fresh activity and
          unconfirmed status.
        </Text>
      ),
      disabled: guestNumberExceedsLimit,
    },
  ]

  const handleSubmit = (values) => {
    cloneEvent(values.includeGuests === Boolean.True)
    onHide()
  }

  return (
    <ModalForm
      title="Clone Event"
      onClose={onHide}
      initialValues={{ includeGuests: Boolean.False }}
      onSubmit={handleSubmit}
      submitText="Clone Event"
      size="md"
    >
      {({ control }) => (
        <Flex flexDirection="column" gap={8}>
          <RadioButtons
            name="includeGuests"
            control={control}
            options={options}
            spacing={8}
          />
          {guestNumberExceedsLimit && (
            <Text color="red.500" ml={7} mt={-10}>
              Only events with fewer than {" "}
              {CLONE_WITH_GUESTS_LIMIT.toLocaleString("en-US")} guests can be cloned with guests.
            </Text>
          )}

        </Flex>
      )}
    </ModalForm>
  )
}

export default CloneEvent
